import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import DownshiftMultiple from '../../inputs/MultipleInput';

import PermIdentity from '@material-ui/icons/PermIdentity';

class DialogRoleSelect extends React.Component {

    state = {
        selectedroles: []
    };

    handleUpdate = (name, values) => {
        console.log(name, values);
        this.setState({ [name]: values });
    };

    render() {
        const { selectedroles } = this.state;
        const { intl, suggestions } = this.props;
        console.log(selectedroles);
        return (
            <Dialog
                open={true}
                onClose={(event) => this.props.onClose(null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_auto_column align_center margin_top_24 width100">
                        <div className="flex_auto_row width100">
                            <PermIdentity className="c_disabled margin_right_6" />
                            <div className="flex_auto_row button-message barlowcondensed_medium c_state">
                                {intl.formatMessage({ id: 'communication_send_to' })}
                            </div>
                        </div>
                        <DownshiftMultiple
                            id="execute_permits"
                            label={intl.formatMessage({ id: 'communication_send_direct_label' })}
                            suggestions={suggestions}
                            value={selectedroles}
                            name="selectedroles"
                            onChange={this.handleUpdate}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(event) => this.props.onClose(null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button onClick={(event) => this.props.onClose(selectedroles)} disabled={!selectedroles || selectedroles.length === 0} color="primary" autoFocus>
                        <FormattedMessage id="accept" />
                    </Button>

                </DialogActions>
            </Dialog>
        );
    }
}

export default DialogRoleSelect;



// WEBPACK FOOTER //
// ./src/components/complex/communications/DialogRoleSelect.js